import React, { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import {
  Home,
  Users,
  Briefcase,
  Settings,
  FileSliders,
  BadgePercent,
  DiamondPercent,
  Luggage,
  Receipt,
  Image as ImageIcon,
  Truck, // ✅ Imported Truck icon
  ShoppingCart,
  BarChart2,
} from "lucide-react";

// Define prop types for SidebarItem
interface SidebarItemProps {
  to: string;
  icon: ReactNode;
  label: string;
}

const SidebarItem: React.FC<SidebarItemProps> = ({ to, icon, label }) => (
  <NavLink
    to={to}
    className={({ isActive }) =>
      `flex items-center p-4 transition-colors duration-200 ${
        isActive
          ? "bg-blue-100 text-blue-600"
          : "text-gray-700 hover:bg-blue-50"
      }`
    }
  >
    <span className="mr-3">{icon}</span>
    <span>{label}</span>
  </NavLink>
);

const Sidebar: React.FC = () => {
  return (
    <aside className="w-64 bg-white shadow-md h-[calc(100vh-4rem)] fixed top-16 left-0 z-20 transition-all duration-300 ease-in-out overflow-y-auto">
      <nav className="py-4">
        <ul className="space-y-2">
          <li>
            <SidebarItem to="/" icon={<Home size={20} />} label="Dashboard" />
          </li>
          <li>
            <SidebarItem to="/users" icon={<Users size={20} />} label="Users" />
          </li>
          <li>
            <SidebarItem
              to="/bookings"
              icon={<Briefcase size={20} />}
              label="Bookings"
            />
          </li>
          <li>
            <SidebarItem
              to="/terminal-bookings"
              icon={<Receipt size={20} />}
              label="Terminal Bookings"
            />
          </li>
          
          <li>
            <SidebarItem
              to="/abandoned-carts"
              icon={<ShoppingCart size={20} />}
              label="Abandoned Carts"
            />
          </li>
          <li>
            <SidebarItem
              to="/search-analytics"
              icon={<BarChart2 size={20} />}
              label="Search Analytics"
            />
          </li>
          {/* --- NEW TRANSPORT SCHEDULER LINK --- */}
          <li>
            <SidebarItem
              to="/transport-scheduler"
              icon={<Truck size={20} />}
              label="Transport Scheduler"
            />
          </li>
          {/* ------------------------------------ */}
          <li>
            <SidebarItem
              to="/contentManagement"
              icon={<FileSliders size={20} />}
              label="Content Management"
            />
          </li>
          <li>
            <SidebarItem
              to="/negotiatePrice"
              icon={<DiamondPercent size={20} />}
              label="Negotiate Price"
            />
          </li>
          <li>
            <SidebarItem
              to="/commissions"
              icon={<BadgePercent size={20} />}
              label="Commissions"
            />
          </li>
          <li>
            <SidebarItem
              to="/luggage"
              icon={<Luggage size={20} />}
              label="Luggages"
            />
          </li>
          <li>
            <SidebarItem
              to="/coupons"
              icon={<Receipt size={20} />}
              label="Coupons"
            />
          </li>
          <li>
            <SidebarItem
              to="/banners"
              icon={<ImageIcon size={20} />}
              label="Banners"
            />
          </li>
          <li>
            <SidebarItem
              to="/rbdManagement"
              icon={<Luggage size={20} />}
              label="RBD Management"
            />
          </li>
          <li>
            <SidebarItem
              to="/settings"
              icon={<Settings size={20} />}
              label="Settings"
            />
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
